import { Button, Inline } from '@etg/wings';
import { Pictogram } from '@eti/components';
import { useDirection, useSiteContext, useSnowplowTracking, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import {
  CABIN_BAGGAGE,
  CHECK_IN_BAGGAGE,
  getProductPictogramId,
  ONLINE_CHECK_IN,
  productIds,
  SEAT_MAP,
} from '@eti/products';
import { Link } from 'react-router-dom';
import Banner from '../../../../common/components/Banner';
import type { AvailableExtraProductType } from '../../models';
import { routes } from '../../../../constants/routesAndApisConstants';

const buttonWrapperStyles = css`
  width: 100%;
`;

const upsellProductIconStyles = css`
  margin: 16px;
`;

interface UpsellProductBannerProps {
  product: AvailableExtraProductType;
}
const UpsellProductBanner = ({ product }: UpsellProductBannerProps) => {
  const { t } = useTranslation();
  const { brand } = useSiteContext();
  const isRTL = useDirection();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();

  const buttonText: Record<string, string> = {
    [CHECK_IN_BAGGAGE.id]: t('OrderDetails.Banner.UpsellBaggage.Link.Text'), // BAGGAGE
    [CABIN_BAGGAGE.id]: t('OrderDetails.Banner.UpsellBaggage.Link.Text'), // CABIN_BAGGAGE_PER_TRAVELER
    [SEAT_MAP.id]: t('OrderDetails.Banner.UpsellSeat.Link.Text'), // SEATING_SEATMAP
    [ONLINE_CHECK_IN.id]: t('OrderDetails.Banner.UpsellCheckin.Link.Text'), // CHECK_IN
  };

  const handleSnowplowOnAddProduct = (code: string) => {
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Overview',
        action: 'Click',
        label: `ADD_${code}`,
      });
    }
  };

  return (
    <Banner
      data-testid={`upsell-product-${product.id}`}
      description={product.texts.smallCardText || ''}
      footer={
        buttonText[product.id] && (
          <Inline align="end" className={buttonWrapperStyles}>
            <Button
              as={Link}
              data-testid={`upsell-product-${product.id}-banner-link`}
              onClick={() => handleSnowplowOnAddProduct(product.code)}
              to={`${routes.ORDER_DETAILS_EXTRA_PRODUCTS}#product-id-${product.id}`}
            >
              {buttonText[product.id]}
            </Button>
          </Inline>
        )
      }
      icon={
        <Pictogram
          brand={brand.code}
          className={upsellProductIconStyles}
          data-testid={`upsell-product-${product.id}-banner-icon`}
          id={getProductPictogramId(productIds[Number(product.id)], isRTL)}
        />
      }
      title={product.name}
    />
  );
};

export default UpsellProductBanner;
